import React, {Component, Fragment} from 'react'
import './index2.less';
import {Button,} from 'antd';
import {baseUrl,} from '../../api'
import OrderFileComponent from "../../components/bus/order-file";

export default class OrderFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderId: "",
            box: 0,
        }
    }

    componentDidMount() {
        if (this.props.location.state) {
            let orderId = this.props.location.state.orderId;
            this.setState({
                orderId
            })
        }
    }

    downloadPdf = () => {
        window.open(baseUrl + "/api/v1/p/file/orderDeliveryFileDownload?orderId=" + this.state.orderId, "_blank");
    };
    getChildrenMsg = (objType, length) => {
        this.setState({[objType]: length})
    };

    render() {
        return (<Fragment>
                <Button type='primary' onClick={this.downloadPdf} disabled={this.state.box <= 0 }>一键下载</Button>
                <OrderFileComponent orderId={this.state.orderId} {...this.props} getChildrenMsg={this.getChildrenMsg}/>
            </Fragment>
        )
    }
}